import { render, staticRenderFns } from "./Gifs.vue?vue&type=template&id=5ef54c8b"
import script from "./Gifs.vue?vue&type=script&lang=js"
export * from "./Gifs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports